import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";

const ProductList = () => {
  const [boms, setBoms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBoms = async () => {
      const userData = localStorage.getItem("user");
      let token = null;

      if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          token = parsedUser?.access_token;
        } catch (error) {
          console.error("Failed to parse user data:", error);
        }
      }

      if (!token) {
        alert("Token not found. Please login first.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "https://peachpuff-toad-230421.hostingersite.com/api/bom/list",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await response.json();

        if (data?.boms) {
          setBoms(data.boms);
        }
      } catch (error) {
        console.error("Failed to fetch BOMs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBoms();
  }, []);

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    { name: "Product ID", selector: (row) => row.product_id ?? "N/A" },
    { name: "Material ID", selector: (row) => row.material_id ?? "N/A" },
    { name: "Quantity", selector: (row) => row.quantity ?? "N/A" },
    { name: "Unit", selector: (row) => row.unit ?? "N/A" },
    { name: "Wastage %", selector: (row) => row.wastage_percent ?? "N/A" },
    { name: "Cost/Unit", selector: (row) => row.cost_per_unit ?? "N/A" },
    { name: "Total Cost", selector: (row) => row.total_cost ?? "N/A" },
    { name: "Machine", selector: (row) => row.machine ?? "N/A" },
    { name: "Operation", selector: (row) => row.operation ?? "N/A" },
    { name: "Time (min)", selector: (row) => row.operation_time ?? "N/A" },
    { name: "Version", selector: (row) => row.version ?? "N/A" },
    { name: "Is Default", selector: (row) => row.is_default ?? "N/A" },
    { name: "Status", selector: (row) => row.status ?? "N/A" },
    { name: "Approved At", selector: (row) => row.approved_at ?? "N/A" },
  ];

  return (
    <div className="container py-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title text-center mb-4 text-primary">Product BOM List</h2>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={boms}
              pagination
              responsive
              striped
              highlightOnHover
              dense
              persistTableHead
              customStyles={{
                headCells: {
                  style: {
                    backgroundColor: "#f8f9fa",
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductList;

